import { render, staticRenderFns } from "./aedGenericSearch.vue?vue&type=template&id=6672316f&scoped=true&"
import script from "./aedGenericSearch.vue?vue&type=script&lang=js&"
export * from "./aedGenericSearch.vue?vue&type=script&lang=js&"
import style0 from "./aedGenericSearch.vue?vue&type=style&index=0&id=6672316f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672316f",
  null
  
)

export default component.exports